import bg5 from '../../assets/bg5.jpg';
import { Background, Button, ContainerTicket, Info } from './styles';


export function Ticket() {
    return (
    <ContainerTicket>
        <Background src={bg5} alt="two avatars of Fractalia" />
        <Info>
            <h2>Fractalia Party</h2>
            <p>
            We’ll announce the winner of the Fractalia Design Contest 2022 who will be featured in our tree house billboard and will receive a legendary wearable
            </p>
            <h1>
                May 25th - 8PM UTC
            </h1>
            <div className='opction'>
            MINI GAME • Exclusive Wearables for Winners • Panel Discussion with Creators, Marketers, and 3D Designers from DCL • After-Party with DJ GucciToe • Decentraland Events
            </div>
            <Button>
                <a  href="https://bit.ly/3MtW0Up" target="_blank" rel="noreferrer">Register your interest</a>
            </Button>
        </Info>
    </ContainerTicket>
    )
}